import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import { useDeleteCollection } from '../../hooks/useCollections';
import type { CollectionStats } from '../../types';

interface Props {
  collection: CollectionStats | null;
  onOpenChange: (open: boolean) => void;
  onDeleted: () => void;
}

export function DeleteCollectionDialog({ collection, onOpenChange, onDeleted }: Props) {
  const { mutateAsync, isPending } = useDeleteCollection();

  async function handleConfirm() {
    if (!collection) return;
    await mutateAsync(collection.collection_id);
    onDeleted();
    onOpenChange(false);
  }

  return (
    <AlertDialog open={Boolean(collection)} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remover coleção</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja remover{' '}
            {/* break-words: id longo sem espaço esticava o diálogo. */}
            <span className="text-foreground font-semibold break-words">
              "{collection?.collection_id}"
            </span>
            ?
            {(collection?.total_documents ?? 0) > 0 && (
              <>
                {' '}
                Isso removerá{' '}
                <span className="text-destructive font-semibold">
                  {collection?.total_documents} documento(s)
                </span>{' '}
                em cascade.
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          {/* eslint-disable-next-line @typescript-eslint/no-misused-promises -- async event handler */}
          <AlertDialogAction variant="destructive" onClick={handleConfirm} disabled={isPending}>
            {isPending ? 'Removendo…' : 'Remover'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
